import React from 'react';
import Testimonial from './Testimonial';

const testimonials = [
  {
    text: `В живота няма случайни неща, гледах нейно видео в социалните мрежи в много тежък и труден за мен период. Без никакво колебание веднага си запазих час за консултация. Към днешна дата смело мога да кажа ,аз живея втори живот благодарение на тази консултация. Хриси, не е обикновен таролог! Тя е човек с истинска дарба,тя надгражда постоянно тази дарба с нови знания. Тя не изказва лично мнение, не се влияе от настроението си,тя е истински професионалист,който ви предава посланието на картите със собствени думи. Разказва по достъпен,земен и човешки начин на разбираем език. Ако искам да знам истината и да получа правилните насоки и съвети,Хриси е моят таролог. Аз избрах Хриси за всичко важно в живот ми от тук нататък. Сърдечно я препоръчвам на всеки който има нужда от Таро-консултация.`,
    author: 'Искра Иванова',
  },
  {
    text: `Имах натрупано напрежение и неприятности в личния живот,попаднах на Хриси,случайно,вдъхна ми доверие още от момента в който я чух и видях,приятна,отзивчива,изключително отзивчива и помагаща!Като таролог незаменима,това което казва е винаги много точно и истинско,помогна ми изключително много и винаги ще търся помощта и прогнозата и!`,
    author: 'Росица Иванова',
  },
  {
    text: `Няма как да опишеш Хриси с две думи. ❤ Тя е страхотна, а това което прави е просто феноменално. Толкова е добра, описва събитията, хората с такова точност, все едно ги познава, все едно е в живота ми, в умът ми.. Откакто я срещнах се консултирам с нея за всеки въпрос и не греши... За мен тя е страхотен човек и професионалист ❤`,
    author: 'Доника Балабанова',
  },
];

const stats = [
  { value: '65K+', label: 'Последователи' },
  { value: '1400+', label: 'Доволни клиенти' },
  { value: '13+', label: 'Години практика' },
];

const Testimonials: React.FC = () => (
  <>
    <div className="container py-4 py-xl-5">
      <div className="row mb-5">
        <div className="col-md-8 col-xl-6 text-center mx-auto">
          <h2 className="fs-1 fw-bold text-primary">Защо да изберете мен</h2>
        </div>
      </div>
      <div className="text-center text-white-50 bg-primary border rounded border-0 p-3">
        <div className="row">
          {stats.map((stat) => (
            <div className="col" key={stat.label}>
              <div className="p-3">
                <h4 className="display-5 fw-bold text-white mb-0">{stat.value}</h4>
                <p className="mb-0 text-white">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="container mb-5">
      <div className="justify-center row row-cols-1 row-cols-sm-2 row-cols-lg-3">
        {testimonials.map((t, idx) => (
          <Testimonial key={idx} text={t.text} author={t.author} />
        ))}
      </div>
    </div>
  </>
);

export default Testimonials;
